import { getSoundSource, DEFAULT_SOUNDS } from "../sounds/catalog";
import { useEffect, useRef } from "react";
import { advanceTaskTimer, getTaskAlert, isTaskWarningActive } from "../utils/taskTimer";
import { playSound, unlockAudio } from "../utils/audio";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import StarRateIcon from "@mui/icons-material/StarRate";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import StarIcon from "@mui/icons-material/Star";
import StarPurple500Icon from "@mui/icons-material/StarPurple500";
import CelebrationIcon from "@mui/icons-material/Celebration";
// import StarRateIcon from "@mui/icons-material/StarRate";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import startTask from "../AudioFiles/startTaskCut.mp3";
import ScatterPlotIcon from "@mui/icons-material/ScatterPlot";
import { colorThemes } from "../Constants/constants";
const Timer = ({
  id,
  taskIndex,
  tasks,
  setTasks,
  onCompleteTask,
  isAutoMode,
  onManualPlay,
  totalTime,
  totalSavedTime,
  totalBooster,
  totalBreakTime,
  setTotalTime,
  setTotalSavedTime,
  setTotalBooster,
  setTotalBreakTime,
  isSoundOn,
  soundSelections = DEFAULT_SOUNDS,
  isVibrationOn,
  isTaskHighlighed,
  warningTimer,
  initialUserInteraction,
  setInitialUserInteraction,
  currentThemeName,
}) => {
  const customBorder = "none";
  const iconStyle = {
    padding: "0px",
    width: 25,
    height: 25,
    color: "var(--app-text)",
  };
  const iconStyleCustom = {
    padding: "0px",
    width: 25,
    height: 25,
    color: "var(--app-text-faint)",
  };
  const themeColors = colorThemes[currentThemeName];
  const task = tasks[taskIndex];
  const previousTask = useRef(task);
  useEffect(() => {
    const previous = previousTask.current;
    previousTask.current = task;
    if (!task.isTaskRunning || !initialUserInteraction) return;
    if (
      isVibrationOn &&
      previous.remainingTime > 0 && task.remainingTime <= 0 &&
      (task.snoozeTimer || 0) <= 0 &&
      typeof navigator.vibrate === "function"
    ) {
      navigator.vibrate([300, 150, 300]);
    }
    if (!isSoundOn) return;
    const alert = getTaskAlert(
      previous,
      task,
      isAutoMode ? 5 : warningTimer,
      task.taskName.toLowerCase().startsWith("break"),
      isAutoMode
    );
    if (alert) {
      const category = isAutoMode ? "countdown" : "warning";
      playSound(getSoundSource(category, soundSelections[category]));
    }
  }, [task, isAutoMode, soundSelections, warningTimer, isSoundOn, isVibrationOn, initialUserInteraction]);

  const totalSeconds = tasks[taskIndex].remainingTime;
  const minutes =
    totalSeconds < 0
      ? Math.ceil(totalSeconds / 60) // Use Math.ceil for negative values to handle rounding correctly
      : Math.floor(totalSeconds / 60);

  const seconds = Math.abs(totalSeconds % 60); // Take absolute value of seconds to avoid negative seconds

  const formatTime = (time) => {
    return time < 10 ? `0${time}` : time;
  };

  const displayTime = () => {
    if (totalSeconds < 0) {
      return `-${formatTime(Math.abs(minutes))}:${formatTime(seconds)}`;
    } else {
      return `${formatTime(minutes)}:${formatTime(seconds)}`;
    }
  };

  const handleTimerToggle = () => {
    if (task.isTimerLocked) return;
    onManualPlay?.();
    if (isSoundOn) unlockAudio();
    if (!initialUserInteraction) {
      setInitialUserInteraction(true);
    }
    if (!task.isTaskRunning && isSoundOn) {
      playSound(startTask);
    }
    const now = Date.now();
    setTasks((prevTasks) =>
      prevTasks.map((prevTask) => {
        if (prevTask.id !== task.id) return prevTask;
        const updated = advanceTaskTimer(prevTask, now);
        if (updated.isTimerLocked) return updated;
        return {
          ...updated,
          timerRunStartedAt: prevTask.isTaskRunning ? updated.timerRunStartedAt : now,
          isTaskRunning: !prevTask.isTaskRunning,
          timerUpdatedAt: now,
        };
      })
    );
  };

  const handleEndTask = () => { if (!task.isTimerLocked) onCompleteTask(task.id); };

  const removeItem1 = () => {
    if (task.isCompleted && !task.taskName.toLowerCase().startsWith("break")) {
      setTotalTime(
        totalTime -
          (tasks[taskIndex].estimatedTaskTime - tasks[taskIndex].remainingTime)
      );
    }

    setTasks((prevTasks) =>
      prevTasks.filter((prevTask) => prevTask.id !== tasks[taskIndex].id)
    );
  };

  return (
    // main list item
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        maxWidth: "100%",
        boxSizing: "border-box",
        minHeight: "var(--main-task-row-height)",
        width: "100%",
        // backgroundColor: colorMode ? "#e9e9e9" : "#4a4a4a",
        // backgroundColor:
        //   isTaskHighlighed &&
        //   tasks[taskIndex].isTaskRunning &&
        //   tasks[taskIndex].remainingTime < 0
        //     ? "flashing"
        //     : "normal",
        borderRadius: "10px",
        marginBottom: "14px",
        padding: "8px",
        border: customBorder, // Add a black border with 1px width
        // overflowX: 'auto', // Enable horizontal scrolling if needed
        boxShadow: "2px 2px 7px var(--app-shadow)", // Add shadow (adjust values as needed)
        "--background-color": themeColors.listItemColor,
      }}
      className={"main-task-row " + (
        isTaskHighlighed &&
        tasks[taskIndex].isTaskRunning &&
        isTaskWarningActive(task, warningTimer) &&
        tasks[taskIndex].remainingTime >= 0 &&
        tasks[taskIndex].snoozeTimer < 1
          ? "flashing"
          : isTaskHighlighed &&
            tasks[taskIndex].isTaskRunning &&
            tasks[taskIndex].remainingTime < 0 &&
            tasks[taskIndex].snoozeTimer < 1
          ? "overduenormal"
          : tasks[taskIndex].isCompleted
          ? "normal timer-row-completed"
          : "normal"
      )}
      key={id}
    >
      {/* play pause */}
      <div
        className="timer-action-circle"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "38px", // Set the width of the circle
          height: "38px", // Set the height equal to the width to maintain a perfect circle
          borderRadius: "50%", // Makes the element a circle by using border-radius
          marginLeft: "5px",
          border: customBorder, // Add a black border with 1px width
          backgroundColor: "var(--task-inner-bg)",
        }}
      >
        {tasks[taskIndex].isCompleted && (
          <>
            <StarIcon className="timer-completed-star" style={iconStyleCustom}></StarIcon>
            {/* <CelebrationIcon style={iconStyleCustom}></CelebrationIcon> */}
          </>
        )}
        {!tasks[taskIndex].isCompleted && (
          <>
            {!tasks[taskIndex].isTaskRunning ? (
              <PlayArrowIcon aria-disabled={!!task.isTimerLocked} onClick={handleTimerToggle} style={{ ...iconStyle, opacity: task.isTimerLocked ? 0.35 : 1 }}>
                Start
              </PlayArrowIcon>
            ) : (
              <PauseIcon aria-disabled={!!task.isTimerLocked} onClick={handleTimerToggle} style={{ ...iconStyle, opacity: task.isTimerLocked ? 0.35 : 1 }}>
                Pause
              </PauseIcon>
            )}
          </>
        )}
      </div>
      {/* timer  */}
      <div
        className={"timer-time-pill" + (task.isTimerLocked ? " timer-locked" : "")}
        aria-disabled={!!task.isTimerLocked}
        style={{
          width: "50px", // Set the width of the circle
          height: "30px", // Set the height equal to the width to maintain a perfect circle
          borderRadius: "25px", // Makes the element a circle by using border-radius
          backgroundColor: task.isTimerLocked ? "#facc15" : "var(--task-inner-bg)",
          border: customBorder, // Add a black border with 1px width
          marginLeft: "1px", // Reduce the left margin here
          marginRight: "1px", // Reduce the right margin here
          cursor: task.isTimerLocked ? "default" : "pointer",
        }}
        onClick={() => {
          if (task.isTimerLocked) return;
          setTasks((prevTasks) =>
            prevTasks.map((prevTask) =>
              prevTask.id === tasks[taskIndex].id
                ? {
                    ...prevTask,
                    snoozeTimer:
                      tasks[taskIndex].remainingTime < 30
                        ? tasks[taskIndex].snoozeTimer < 600
                          ? tasks[taskIndex].snoozeTimer + 150
                          : tasks[taskIndex].snoozeTimer
                        : 0,
                  }
                : prevTask
            )
          );
        }}
      >
        <div style={{ paddingTop: "3px" }}>
          <b
            style={{
              fontSize: "12px", // Reduced size for tight spaces
              // fontFamily: "'Cinzel', serif",
              letterSpacing: "1px", // Compact layout
              textAlign: "center", // Improves alignment
              color:
                task.isTimerLocked ? "#422006" : totalSeconds > 0 || !isTaskHighlighed
                  ? "var(--timer-color)"
                  : tasks[taskIndex].isTaskRunning
                  ? "#e17878" //red
                  : "var(--timer-color)",
            }}
          >
            {displayTime()}
          </b>
          {/* <span style={{ fontSize: '8px' }}> /{estimatedTaskTime}</span> */}
        </div>
      </div>
      {/* Task Name */}
      <div
        className="timer-task-name-box"
        style={{
          fontFamily: "Lora",
          fontSize: "1rem",
          width: "200px", // Set the width of the circle
          //height: '38px', // Set the height equal to the width to maintain a perfect circle
          borderRadius: "5px", // Makes the element a circle by using border-radius
          backgroundColor: "var(--task-inner-bg)", // Change the background color as needed
          textAlign: "left",
          minHeight: "38px", // Set a minimum height
          maxHeight: "auto", // Allow the div to grow in height
          overflow: "hidden", // Hide overflow content
          margin: "3px",
          border: customBorder, // Add a black border with 1px width
          marginLeft: "1px", // Reduce the left margin here
          marginRight: "1px", // Reduce the right margin here
        }}
      >
        <p
          style={{
            padding: "8px",
            margin: "1px",
            overflowWrap: "break-word",
            wordWrap: "break-word",
            color: "var(--app-text)",
            fontWeight: 500,
          }}
        >
          {tasks[taskIndex].taskName}
        </p>
      </div>
      {/* Complete or close  */}
      <div>
        {!task.isCompleted && !task.isTimerLocked && (
          <>
            <CheckCircleIcon
              className="timer-complete-action"
              aria-disabled={!!task.isTimerLocked}
              onClick={handleEndTask}
              style={{ ...iconStyle, opacity: task.isTimerLocked ? 0.35 : 1 }}
            >
              End
            </CheckCircleIcon>
          </>
        )}
        {(task.isCompleted || task.isTimerLocked) && (
          <>
            <CancelIcon
              className="timer-completed-remove"
              aria-label="Remove task"
              onClick={() => {
                removeItem1();
              }}
              style={iconStyle}
            >
              Remove
            </CancelIcon>
          </>
        )}
      </div>
    </div>
  );
};
export default Timer;
